import React from 'react';
import styled from 'fe-styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import { Link } from 'fe-appdir-comp-link';

const PROP_TYPES = {
  title: PropTypes.string.isRequired,
  graphic: PropTypes.func,
  textPadding: PropTypes.string,
  linkTo: PropTypes.string,
  gaTrackId: PropTypes.string,
  gaTrackInfo: PropTypes.string,
};

const DEFAULT_PROPS = {
  graphic: null,
  textPadding: theme.paddingBase,
};

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  ${(p) => (p.isCentered ? 'justify-content: center' : null)};
  background-color: ${theme.colorWhite};
  color: ${theme.colorBase};
  height: 100%;
`;

const TitleWrapper = styled.div`
  padding: ${(p) => p.padding};
  font-weight: ${theme.fontWeightSemibold};
  font-family: ${theme.fontFamilyPrimary};
  ${(p) => (p.isCentered ? 'text-align: center' : null)};
`;

// Renders a shadow on cards that are not linked
const ShadowWrapper = styled.div`
  box-shadow: ${theme.boxShadowCard};
`;

// Wraps card in Link and renders different shadows for hover/focus state
const InvisibleLink = styled(Link)`
  box-shadow: ${theme.boxShadowCard};
  display: block;
  height: 100%;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: all ${theme.transitionTime} ${theme.transitionEasing};

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }

  &:hover,
  &:focus {
    box-shadow: ${theme.boxShadowCardRaised};
    transform: translateY(-6px);
    color: ${theme.colorBrandPrimary};
  }
`;

const MiniCard = ({ title, graphic, textPadding, linkTo, gaTrackId, gaTrackInfo }) => {
  const isLinked = Boolean(linkTo);
  const wrapperProps = isLinked ? { to: linkTo, tabIndex: 0 } : {};
  const CardWrapper = isLinked ? InvisibleLink : ShadowWrapper;
  return (
    <CardWrapper
      {...wrapperProps}
      data-ga-track-id={gaTrackId}
      data-ga-track-info={gaTrackInfo}
    >
      <CardContainer isCentered={!graphic}>
        {graphic ? graphic() : null}
        <TitleWrapper isCentered={!graphic} padding={textPadding}>
          {title}
        </TitleWrapper>
      </CardContainer>
    </CardWrapper>
  );
};

MiniCard.propTypes = PROP_TYPES;
MiniCard.defaultProps = DEFAULT_PROPS;
MiniCard.displayName = 'MiniCard';

export { MiniCard };
